import apiClient from '../connections/api'

export default {
    getMessagesByUser: (_id) => {
        const requestBody = {
            _id
        }
        return apiClient.post('/internalMessagesData/get-messages-by-user', requestBody)
    },
    getAllMessages: () => {
        return apiClient.get('/internalMessagesData/getAllMessages')
    },
    sendMessage: (message) => {
        const requestBody = {
            message
        }
        return apiClient.post('/internalMessagesData/sendMessage', requestBody)
    },
    removeMessage: (_id) => {
        const requestBody = {
            _id
        }
        return apiClient.post('/internalMessagesData/removeMessage', requestBody)
    }
}
